import { useQuery } from '@graphcommerce/graphql'
import { EnteredOptionInput } from '@graphcommerce/graphql-mesh'
import { OrderItemFragment } from '@graphcommerce/magento-customer/components/OrderItem/OrderItem.gql'
import { ProductCustomizableFragment } from '@graphcommerce/magento-product/components/ProductCustomizable/ProductCustomizable.gql'
import { useMemo } from 'react'
import { OrderItemAdditionalFragment } from '../OrderItem/OrderItemAdditional.gql'
import { ReorderItemOptions } from './ReorderItemOptions'
import { ReorderItemOptionsDocument } from './ReorderItemOptions.gql'

type ReorderItemAdjustmentsProps = OrderItemFragment &
  OrderItemAdditionalFragment & {
    setAdjustedOptions: (values: EnteredOptionInput[]) => void
  }

export function ReorderItemAdjustments(props: ReorderItemAdjustmentsProps) {
  const { product_url_key } = props

  const { data } = useQuery(ReorderItemOptionsDocument, {
    variables: { urlKey: product_url_key as string },
  })

  const product = useMemo(() => {
    if (!data) return false
    return data?.products?.items?.at(0) as ProductCustomizableFragment
  }, [data])

  if (!product) {
    return null
  }

  return (
    <div className='flex min-h-[400px] w-full items-center justify-center p-[20px] md:min-w-[400px]'>
      <div>
        <ReorderItemOptions {...props} product={product} />
      </div>
    </div>
  )
}
